/* Generated by @k8s-dashboard/extensions. Do not edit. */
import type { ExtensionManifest } from "@k8s-dashboard/extensions";

/** 호스트 확장 API 버전. 매니페스트 major가 다르면 빌드가 실패합니다. */
export const EXTENSION_API_VERSION = "1.0";

/** 의존성 위상 순서(같은 층은 id 사전순). 이 배열이 번들에 들어가는 확장 전부입니다. */
export const extensionManifests = [
  {
    "schemaVersion": 1,
    "id": "logs-explorer",
    "title": "Logs Explorer",
    "apiVersion": "1.0",
    "version": "1.0.0",
    "dependsOn": [],
    "module": {
      "specifier": "@/features/logs/LogsExplorer",
      "chunk": "LogsExplorer",
      "maxGzipBytes": 8192
    },
    "backend": {
      "endpoints": [
        "GET /api/v1/clusters/{clusterId}/logs"
      ],
      "queryRefs": []
    },
    "routes": [
      {
        "id": "logs",
        "path": "/logs",
        "component": "LogsExplorer",
        "capability": "always"
      }
    ],
    "nav": [
      {
        "id": "nav-logs",
        "routeId": "logs",
        "label": "Logs Explorer",
        "group": "observe",
        "order": 65
      }
    ],
    "sections": [],
    "widgets": [],
    "commands": []
  }
] as const satisfies readonly ExtensionManifest[];
